import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallCenterBaggageItemComponent } from './call-center-baggage-item.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CallCenterBaggageItemComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [CallCenterBaggageItemComponent],
})
export class CallCenterBaggageItemModule {}
